module.exports = __webpack_public_path__ + "img/shutterstock_447406066.ab940ef6.png";